import { useEffect, useState } from 'react';

/** Troca de aba sem recarregar. Sinal próprio porque pushState não avisa ninguém. */
const EVENTO = 'aba:trocou';

function lerDoEndereco(ids: readonly string[], padrao: string): string {
  const alvo = window.location.hash.replace('#', '');
  return ids.includes(alvo) ? alvo : padrao;
}

/**
 * Manda para uma aba e registra no histórico.
 *
 * Cada aba tem endereço próprio para o link poder ser mandado sozinho no
 * WhatsApp, que é justamente o motivo de "quem ensina" e "dúvidas" merecerem
 * existir separados.
 */
export function irParaAba(id: string) {
  if (window.location.hash !== `#${id}`) {
    window.history.pushState(null, '', `#${id}`);
  }
  window.dispatchEvent(new CustomEvent(EVENTO));
}

/**
 * Qual aba está aberta, lida do endereço.
 *
 * Vive no endereço, e não num estado compartilhado, para que o cabeçalho e o
 * painel de abas se mantenham sincronizados sem um conhecer o outro, e para
 * que voltar no navegador funcione.
 */
export function useAbaAtiva(ids: readonly string[], padrao: string): string {
  const [atual, setAtual] = useState(() => lerDoEndereco(ids, padrao));

  useEffect(() => {
    const sincronizar = () => setAtual(lerDoEndereco(ids, padrao));
    sincronizar();
    window.addEventListener(EVENTO, sincronizar);
    window.addEventListener('hashchange', sincronizar);
    window.addEventListener('popstate', sincronizar);
    return () => {
      window.removeEventListener(EVENTO, sincronizar);
      window.removeEventListener('hashchange', sincronizar);
      window.removeEventListener('popstate', sincronizar);
    };
  }, [ids, padrao]);

  return atual;
}
